import { NoResults } from "~/icons/NoResults/NoResults";
import { Box } from "../Box/Box";
import { Stack } from "../Stack/Stack";
import { Text } from "../Text/Text";

export function NoMatch() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexGrow={1}
    >
      <Box maxWidth="small">
        <Stack space="1" align="center">
          <NoResults />
          <Text align="center" size="large" weight="semi-strong">
            No results found
          </Text>
          <Text size="small" align="center">
            Please check your spelling or try again using different keywords
          </Text>
        </Stack>
      </Box>
    </Box>
  );
}
